import { render, staticRenderFns } from "./DialogLogin-v2.vue?vue&type=template&id=796aae36"
import script from "./DialogLogin-v2.vue?vue&type=script&lang=js"
export * from "./DialogLogin-v2.vue?vue&type=script&lang=js"
import style0 from "./DialogLogin-v2.vue?vue&type=style&index=0&id=796aae36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports